import { PatientShortSummary } from "../../../clinic/clinicTypes";

export class ClinicUtil {
  public static getPatientOneLiner = (summary: PatientShortSummary): string => {
    if (!summary) return "";
    let retString = "";
    if (summary.gender) {
      retString += summary.gender;
    }
    if (summary.age) {
      if (retString.length > 0) {
        retString += ", ";
      }
      retString += summary.age;
    }
    if (summary.main) {
      if (retString.length > 0) {
        retString += " with ";
      }
      retString += summary.main;
    }
    if (summary.visitReason) {
      if (retString.length > 0) {
        retString += ", ";
      }
      retString += summary.visitReason;
    }
    return retString;
  };
}

export const convertClinicName = (clinicName: string): string =>
  encodeURIComponent(clinicName.trim().toLowerCase()).replaceAll("%20", "_");
